const initPolicy = () => {
    

    $('.order-to-pay-btn').click(e => {
        debugger;
        var elm = $(e.target);
        var data = elm.data("expressshipping");
        if (data ==="express") {
            return;
        }
        $('.factor-policy-modal').css('display', 'flex');
        $('.modal-overlay').show();
        $('#site-container').addClass('blur');
        $('body').css('overflow', 'hidden');
        e.preventDefault();
    })
    $('.modal-close-window').click(e => {
        $('.factor-policy-modal').css('display', 'none');
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');
    })
    $('.modal-overlay').click(e => {
        $('.factor-policy-modal').css('display', 'none');
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');
    })

};

export {
    initPolicy
};
